import axios from '@/http/axios'

export default {
  fetchList: () => {
    return axios.get(`/media-files`)
  },
  updateRelation: (oid, payload) => {
    return axios.put(`/media-files/${oid}/update-relation`, payload)
  }
}